import React from 'react';

const GenericTemplate = prop => {
  return (
    <h3>Generic Template</h3>
  )
}

export default GenericTemplate;